export const objectEntries = <T extends Record<string, any>>(
  obj: T,
): [keyof T, T[keyof T]][] => {
  return Object.entries(obj);
};
